module.exports = class Errors {
	/**
	 * Create a new Errors instance.
	 */
	constructor() {
		this.errors = {};
	}

	/**
	 * Determine if an errors exists for the given field.
	 *
	 * @param {string} field
	 */
	has(field) {
		return Object.prototype.hasOwnProperty.call(this.errors, field);
	}

	/**
	 * Determine if we have any errors.
	 */
	any() {
		return Object.keys(this.errors).length > 0;
	}

	/**
	 * Retrieve the number error message for a field.
	 *
	 * @param {string} field
	 */
	count(field) {
		if (this.errors[field]) {
			return this.errors[field].length;
		}

		return undefined;
	}

	/**
	 * Retrieve the error message for a field.
	 *
	 * @param {string} field
	 */
	get(field) {
		if (this.errors[field]) {
			return this.errors[field];
		}

		return undefined;
	}

	all() {
		// console.log(this.errors);

		return this.errors.map((field) => this.get(field));
	}

	/**
	 * Record the new errors.
	 *
	 * @param {object} errors
	 */
	record(errors) {
		this.errors = errors;
	}

	/**
	 * Clear one or all error fields.
	 *
	 * @param {string|null} field
	 */
	clear(field) {
		if (field) {
			delete this.errors[field];

			return;
		}

		this.errors = {};
	}
};
